import { Box, Button, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { useAuth } from '@src/auth/hooks/useAuth';
import { Role } from '@src/constants/Roles';

interface Props {
  recordCount: number;
  numberOfPages: number;
  currentPage: number;
  setPageNumber(page: number): void;
  updateRotation(rotation: number): void;
  zoom(increase: boolean): void;
  onImportFiles(): void;
}

function Footer({
  recordCount,
  numberOfPages,
  currentPage,
  setPageNumber,
  updateRotation,
  zoom,
  onImportFiles,
}: Props) {
  const [page, setPage] = useState(1);
  const [, setRotation] = useState(0);
  const { hasRole } = useAuth();

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  const handleBack = () => {
    if (currentPage > 1) {
      setPageNumber(currentPage - 1);
    }
  };

  const handleForward = () => {
    if (currentPage < numberOfPages) {
      setPageNumber(currentPage + 1);
    }
  };

  const rotate = (left: boolean) => {
    setRotation((prevRotation: number) => {
      let rota = (prevRotation - (left ? 90 : -90)) % 360;

      if (rota < 0) {
        //ensure rotation is always positive
        rota += 360;
      }

      updateRotation(rota);
      return rota;
    });
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      })}>
      <Box sx={{}}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            aria-label="back"
            onClick={() => rotate(true)}
            size="medium"
            color="primary">
            <RotateLeftIcon />
          </IconButton>
          <IconButton
            aria-label="back"
            onClick={() => rotate(false)}
            size="medium"
            color="primary">
            <RotateRightIcon />
          </IconButton>
          <IconButton
            aria-label="back"
            onClick={() => zoom(false)}
            size="medium"
            color="primary">
            <ZoomOutIcon />
          </IconButton>
          <IconButton
            aria-label="back"
            onClick={() => zoom(true)}
            size="medium"
            color="primary">
            <ZoomInIcon />
          </IconButton>
          {numberOfPages > 1 && (
            <>
              <Typography variant="body1">
                Page {page} of {numberOfPages}
              </Typography>
              <Box>
                <IconButton
                  aria-label="back"
                  onClick={handleBack}
                  size="medium"
                  color="primary">
                  <ChevronLeftIcon />
                </IconButton>
                <IconButton
                  aria-label="back"
                  onClick={handleForward}
                  size="medium"
                  color="primary">
                  <ChevronRightIcon />
                </IconButton>
              </Box>
            </>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          textAlign: 'center',
        }}>
        <Typography variant="body1">{recordCount} Items</Typography>
      </Box>
      <Box
        sx={{
          textAlign: 'right',
          padding: '10px',
        }}>
        {hasRole(Role.ScanImporter) && (
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={onImportFiles}>
            Import Files
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default Footer;
